import Vue from "vue";
import { VueTreeList, Tree, TreeNode } from 'vue-tree-list-v2';
import VueContext from 'vue-context';
import { parse, stringify, toJSON, fromJSON } from 'flatted';

import AlphanumericEncoder from 'alphanumeric-encoder';
import { romanToArab, arabToRoman, isValidArab, isValidRoman } from 'roman-numbers';
const encoder = new AlphanumericEncoder()
import { v4 as uuidv4 } from 'uuid';
import treeviewMixin from '../mixins/TreeViewEditorMixin.js'

Vue.component("notes-treeview-viewer", {
    components: {
        VueContext,
        VueTreeList
    },
    mixins: [treeviewMixin],
    props: ["data", "original", "annexId"],
    data() {
        return {
            currentNode: null,
            treeData: new Tree([]),
            showFormModal: false,
            currentEvent: null,
            isEditing: false,
            isAdding: false,
            showItemModal: false,
            viewModel: {
                id: 0,
                referenceNumber: null,
                name: null,
            }
        };
    },

    methods: {
        onClick: function (params) {

            this.currentNode = params;

        },
        contextClick: function (event, data, orientation) {

            this.showFormModal = false;

            if (event == 'delete') {

                this.currentNode.isDeleted = this.currentNode.isDeleted ? false : true;
                this.currentNode.changeType = this.currentNode.changeType == 'Deleted' ? null : 'Deleted';
                this.updateParent();
            } else if (event == 'edit') {

                this.isEditing = true;
                this.isAdding = false;
                this.viewModel = Object.assign({}, this.currentNode);

                if (this.currentNode.changeType == 'Added') {
                    this.viewModel.updatedText = this.viewModel.name;
                    this.viewModel.updatedReferenceNumber = this.viewModel.referenceNumber;
                    this.viewModel.updatedDefinesSymbol = this.viewModel.definesSymbol;

                    this.viewModel.updatedClassificationSystem = this.currentNode.classificationSystem;
                    this.viewModel.excluded = this.currentNode.excluded;
                } else {
                    this.viewModel.updatedText = this.currentNode.updatedText ? this.currentNode.updatedText : this.viewModel.name;
                    this.viewModel.updatedReferenceNumber = this.currentNode.updatedReferenceNumber ? this.currentNode.updatedReferenceNumber : this.viewModel.referenceNumber;
                    this.viewModel.updatedDefinesSymbol = this.currentNode.updatedDefinesSymbol ? this.currentNode.updatedDefinesSymbol : this.viewModel.definesSymbol;
                    this.viewModel.updatedClassificationSystem = this.currentNode.updatedClassificationSystem ? this.currentNode.updatedClassificationSystem : this.viewModel.classificationSystem;
                    this.viewModel.excluded = this.currentNode.excluded;

                }

                this.showFormModal = true;


            } else {

                this.isEditing = false;
                this.isAdding = true;
                if (orientation == 'NoteItem') {
                    this.$refs['noteItemComponent' + this.currentNode.id].addFromParent();

                } else {

                    this.viewModel = {
                        pid: this.currentNode ? this.currentNode.pid : 0,
                        orientation: orientation,
                        addTreeNodeDisabled: true,
                        addLeafNodeDisabled: true,
                        editNodeDisabled: true,
                        delNodeDisabled: true,
                        isLeaf: false,
                        changeType: 'Added',
                        dragDisabled: false,
                        parent: this.currentNode ? this.currentNode.parent : null,
                        id: crypto.randomUUID(),
                        name: null,
                        originalName: null,
                        referenceNumber: null,
                        displayOrder: this.currentNode ? this.currentNode.displayOrder : 1,
                        excluded: false,
                        classificationSystem: null,
                        definesSymbol: null

                    }

                    if (orientation != 'Child' && orientation != 'ChildNote' && this.currentNode) {
                        this.viewModel.nearId = this.currentNode.id;
                        this.viewModel.pid = this.currentNode.pid;
                    }

                    this.showFormModal = true;
                }


            }

        },

        onContextOpen: function (event, data, top, left) {

            console.log(data);

            this.currentNode = data;
        },
        update: function () {
            let dmp = new diff_match_patch();

            if (this.isEditing) {

                if (!this.currentNode.changeType || this.currentNode.changeType == 'Updated') {
                    this.currentNode.updatedText = this.viewModel.updatedText;
                    this.currentNode.updatedReferenceNumber = this.viewModel.updatedReferenceNumber;
                    this.currentNode.updatedDefinesSymbol = this.viewModel.updatedDefinesSymbol;
                    this.currentNode.excluded = this.viewModel.excluded;
                    this.currentNode.updatedClassificationSystem = this.viewModel.updatedClassificationSystem;


                    this.currentNode.changeType = 'Updated';

                    var previousText = this.currentNode.originalDisplayName;
                    var newText = `${this.$options.filters.stripParagraphTags(this.currentNode.updatedText)}`;
                    if (this.currentNode.updatedDefinesSymbol) {
                        newText += ` (${this.currentNode.updatedDefinesSymbol})`;
                    } else if (this.currentNode.definesSymbol) {
                        newText += ` (${this.currentNode.definesSymbol})`;

                    }

                    if (this.currentNode.classificationSystem) {
                        newText += ` (${this.currentNode.classificationSystem})`;

                    }
                    this.currentNode.displayName = this.prettyDiff(previousText, newText);

                    this.currentNode.referenceNumberDisplayName = this.prettyDiff(this.currentNode.referenceNumber, this.currentNode.updatedReferenceNumber);
                } else {
                    this.currentNode.name = this.viewModel.updatedText;
                    this.currentNode.definesSymbol = this.viewModel.updatedDefinesSymbol;
                    this.currentNode.excluded = this.viewModel.excluded;
                    this.currentNode.classificationSystem = this.viewModel.classificationSystem;
                    var newText = `${this.currentNode.name}`;


                    this.currentNode.referenceNumber = this.viewModel.updatedReferenceNumber;

                    this.currentNode.displayName = this.prettyDiff('', newText);


                    this.currentNode.referenceNumberDisplayName = this.prettyDiff('', this.currentNode.referenceNumber);

                }


                this.showFormModal = false;
            } else {

                var newText = `${this.viewModel.name}`;
                if (this.viewModel.definesSymbol) {
                    newText += ` (${this.viewModel.definesSymbol})`;

                }

                if (this.viewModel.classificationSystem) {
                    newText += ` (${this.viewModel.classificationSystem})`;

                }

                this.viewModel.displayName = this.prettyDiff('', newText);

                this.viewModel.referenceNumberDisplayName = this.prettyDiff('', this.viewModel.referenceNumber);
                var node = new TreeNode(this.viewModel)
                if (this.viewModel.orientation == 'Above') {
                    if (this.currentNode) {
                        var pos = this.currentNode.parent.findChildIndex(this.currentNode);

                        this.currentNode.parent.children.splice(pos + 0, 0, node);

                    } else {
                        if (this.treeData.children) {
                            this.treeData.children = [];

                        }
                        this.treeData.addChildren(node);
                    }


                } else if (this.viewModel.orientation == 'below') {

                    if (this.currentNode) {
                        var pos = this.currentNode.parent.findChildIndex(this.currentNode);
                        this.currentNode.parent.children.splice(pos + 1, 0, node);
                    } else {
                        this.treeData.children = [];
                        this.treeData.addChildren(node);
                    }

                } else if (this.viewModel.orientation == 'child') {

                    if (!this.currentNode.children) this.currentNode.children = [];
                    this.currentNode.addChildren(node);
                }

                this.showFormModal = false;

            }


            this.$nextTick();
            this.updateParent();

        },
        getNewTree: function () {

            var out = this.flatten([], this.treeData.children);

            var newTree = out.map(function mapper(item) {
                var newItem = Object.assign({}, item);
                if (newItem.children) {
                    newItem.children = undefined;
                }
                if (newItem.changeType == 'Added' && item.id == 'X') {
                    newItem.id = 0;
                }
                newItem.parent = undefined;

                if (item.pid == 0) newItem.pid = null;
                if (item.pid) {
                    newItem.pid = item.pid.toString();
                }
                return newItem;
            })
            return newTree;
        },
        flatten: function (into, node) {
            if (node == null) return into;
            if (Array.isArray(node)) return node.reduce(this.flatten, into);
            into.push(node);
            return this.flatten(into, node.children);
        },
        rearrange: function (type) {
            let dmp = new diff_match_patch();
            var pos = this.currentNode.parent.findChildIndex(this.currentNode);
            var items = this.currentNode.parent.children.slice(pos);
            items.map((x, i) => {
                var index = i + 1;
                if (type == 'arab') {
                    if (x.changeType == 'Updated') {
                        x.updatedReferenceNumber = this.getParentReferenceNumber(this.currentNode.parent, index.toString(), true);

                    } else if (x.changeType == 'Added' || !x.changeType) {
                        x.referenceNumber = this.getParentReferenceNumber(this.currentNode.parent, index.toString(), true);

                    }

                } else if (type == 'alphaupper') {
                    if (x.changeType == 'Updated') {
                        x.updatedReferenceNumber = this.getParentReferenceNumber(this.currentNode.parent, encoder.encode(index).toUpperCase(), true);

                    } else if (x.changeType == 'Added' || !x.changeType) {
                        x.referenceNumber = this.getParentReferenceNumber(this.currentNode.parent, encoder.encode(index).toUpperCase(), true);

                    }


                } else if (type == 'alphalower') {
                    if (x.changeType == 'Updated') {
                        x.updatedReferenceNumber = this.getParentReferenceNumber(this.currentNode.parent, encoder.encode(index).toLowerCase(), true);

                    } else if (x.changeType == 'Added' || !x.changeType) {

                        x.referenceNumber = this.getParentReferenceNumber(this.currentNode.parent, encoder.encode(index).toLowerCase(), true);

                    }

                } else if (type == 'romanupper') {
                    if (x.changeType == 'Updated') {
                        x.updatedReferenceNumber = this.getParentReferenceNumber(this.currentNode.parent, arabToRoman(index).toUpperCase(), true);

                    } else if (x.changeType == 'Added' || !x.changeType) {
                        x.referenceNumber = this.getParentReferenceNumber(this.currentNode.parent, arabToRoman(index).toUpperCase(), true);

                    }

                } else if (type == 'romanlower') {
                    if (x.changeType == 'Updated') {
                        x.updatedReferenceNumber = this.getParentReferenceNumber(this.currentNode.parent, arabToRoman(index).toLowerCase(), true);

                    } else if (x.changeType == 'Added' || !x.changeType) {
                        x.referenceNumber = this.getParentReferenceNumber(this.currentNode.parent, arabToRoman(index).toLowerCase(), true);

                    }
                }

                var diffRef;

                if (x.changeType == 'Updated') {
                    diffRef = dmp.diff_main(x.referenceNumber, x.updatedReferenceNumber);
                } else if (x.changeType == 'Added' || !x.changeType) {
                    diffRef = dmp.diff_main('', x.referenceNumber);

                }
                if (diffRef) {
                    x.referenceNumberDisplayName = `${dmp.diff_prettyHtml(diffRef)}`;

                }

                if (x.updatedReferenceNumber != x.referenceNumber) {
                    if (!x.changeType || x.changeType == 'Updated') {
                        x.changeType = 'Updated';
                    }
                }
                return x;
            });

            this.currentNode.parent.children.map((x, i) => {
                x.displayOrder = i + 1;
                if (!x.changeType || x.changeType == 'Updated') {
                    x.changeType = 'Updated';
                }
                return x;
            })

            this.updateParent();


        },
        getParentReferenceNumber: function (parentNode, previousReference, firstParent) {
            var referenceNumber = parentNode.updatedReferenceNumber ? parentNode.updatedReferenceNumber : parentNode.referenceNumber;

            if (referenceNumber) {
                //if (parentNode.parent) {
                //    var parent = parentNode.parent;
                //    if (parent.referenceNumberDisplayName) {
                //        var parentReference = parent.updatedReferenceNumber ? parentNode.parent : parent.referenceNumber;
                //        return this.getParentReferenceNumber(parent, `${referenceNumber}.${previousReference}`);
                //    }
                //}
                return `${referenceNumber}.${previousReference}`
            }
            return previousReference;
        },
        drop: function (node) {

            node.node.isDragged = true;
            node.node.changeType = 'Updated';
            this.$nextTick();

            this.updateParent();

        },
        dropBefore: function (node) {



        },
        dropAfter: function (node) {
            console.log('after')
            console.log(node)
        },
        updateParent: function () {
            console.log(this.treeData)
            this.$nextTick();
            this.$emit('setsymbols', this.annexId);
            this.$emit("update:data", this.getNewTree());

        }

    },
    computed: {
        hasSelected: function () {
            if (this.currentNode) return true;
            //if (this.original && this.original.length == 0) return true;
            return false;
        },

    },
    watch: {
        //currentNode: function () {

        //    this.updateParent();

        //}
    },
    mounted() {
        if (this.original && this.original.length > 0) {
            this.treeData = new Tree(this.original);


        }
    },
    template: `
	<div >
		<div class="columns">
			<div class="column">
				<div class="buttons has-addons">
					<b-field class="">
					    <b-dropdown aria-role="list">
                            <template #trigger="{ active }">
                                <b-button
                                    size="is-small"
                                    label="Add"
                                    icon-right="plus" />
                            </template>
                            <b-dropdown-item aria-role="listitem" @click="contextClick('add', null, 'Above')">Above</b-dropdown-item>
                            <b-dropdown-item aria-role="listitem" @click="contextClick('add', null, 'Below')">Below</b-dropdown-item>
                            <b-dropdown-item aria-role="listitem" @click="contextClick('add', null, 'Child')" :disabled="!hasSelected">Child</b-dropdown-item>
                            <b-dropdown-item aria-role="listitem" @click="contextClick('add', null, 'NoteItem')" :disabled="!hasSelected">Note Item</b-dropdown-item>

                        </b-dropdown>
						<b-button size="is-small"
							icon-left="minus"  @click="contextClick('edit', null)" :disabled="!hasSelected">
								Edit
						</b-button>
						<b-button size="is-small"
							icon-left="trash-alt" @click="contextClick('delete')"  :disabled="!hasSelected">
								Delete
						</b-button>
                         <b-dropdown aria-role="list" :disabled="!hasSelected">
                            <template #trigger="{ active }">
                                <b-button
                                    size="is-small"
                                    label="Arrange Numbering"
                                    icon-right="arrow-down-short-wide" />
                            </template>
                            <b-dropdown-item aria-role="listitem" @click="rearrange('arab')">Arab</b-dropdown-item>
                            <b-dropdown-item aria-role="listitem" @click="rearrange('alphaupper')">Alphabetic Upper</b-dropdown-item>
                            <b-dropdown-item aria-role="listitem" @click="rearrange('alphalower')">Alphabetic Lower</b-dropdown-item>
                            <b-dropdown-item aria-role="listitem" @click="rearrange('romanupper')">Roman Upper</b-dropdown-item>
                            <b-dropdown-item aria-role="listitem" @click="rearrange('romanlower')">Roman Lower</b-dropdown-item>
                        </b-dropdown>
					</b-field>
				</div>
			</div>
		</div>
		<vue-tree-list
				:model="treeData"
				v-bind:default-expanded="true"
                @drop="drop"
                @drop-after="dropAfter"
                @drop-before="dropBefore"  
			>
				<template v-slot:leafNameDisplay="props">
					<div  class="entity-row mt-1" @click.prevent="onClick(props.model)" @contextmenu.prevent="$refs.notesMenu.open($event, props.model)" 
                        :class=" { 
                            'has-background-info-light': currentNode != null && currentNode.id == props.model.id, 
                            'has-linethrough': props.model.changeType == 'Deleted', 
                            'has-background-success-light': props.model.isDragged
                        }">
						<div class="entity-row-reference-number pr-2 pl-1">{{ props.model.updatedReferenceNumber ? props.model.updatedReferenceNumber : props.model.referenceNumber }}</div>
						
						<div class="entity-row-display-name" >{{ props.model.updatedText ? props.model.updatedText : props.model.name }}</div>
							
					</div>
                      
                   
				</template>
				<template v-slot:treeNodeIcon="props" class="is-inline-flex">
                    <span class="is-inline-flex">
                        <span class="icon-text" v-if="props.model.changeType == 'Added'">
                            <span class="icon">
                                <i class="fa fa-plus"></i>
                            </span>
                        </span>
                        <span class="icon-text"  v-if="(props.model.children && props.model.children.length > 0 && !props.model.isNote) || props.model.showNoteIcon">
                            <span class="icon">
                                <i v-if="props.model.children && props.model.children.length > 0 && !props.model.isNote" class="fa fa-sitemap"></i>
                                <i v-else-if="props.model.showNoteIcon" class="fa fa-comment has-text-info"></i>
                                
                            </span>
                        </span>
                        <span class="icon-text" v-if="props.model.excluded">
                            <span class="icon">
                                <i class="fa fa-circle-xmark"></i>
                            </span>
                        </span>
                        <span class="icon-text"  v-else >
                            <span class="icon">
                               <i  class="fa fa-fw"></i>
                            </span>
                        </span>
                    </span>
				</template>
                <template v-slot:footer="props">
                  <note-items-editor-v2 :show-new="showNew" v-on:triggerchanges="updateParent()" :ref="'noteItemComponent'+props.model.id" :items.sync="props.model.items" :note="props.model"  :classification-system.sync="props.model.classificationSystem" :has-four-item-columns.sync="props.model.hasFourItemColumns"></note-items-editor-v2>
                   
                </template>

			</vue-tree-list>
			<vue-context ref="notesMenu" v-slot="{ data }" @open="onContextOpen">
				<li class="v-context__sub">
					<a href="#" >Add</a>
					<ul class="v-context">
						<li>
							<a @click.prevent="contextClick('add', data, 'Above')">Above</a>
						</li>
						<li>
							<a @click.prevent="contextClick('add', data, 'below')">Below</a>
						</li>
						<li>
							<a @click.prevent="contextClick('add', data, 'child')">Child</a>
						</li>
                        <li>
							<a @click.prevent="contextClick('add', data, 'NoteItem')">Note Item</a>
						</li>
					</ul>
				</li>
				<li>
					<a href="#" @click.prevent="contextClick('edit', data)">Edit</a>
				</li>
				<li>
					<a href="#" @click.prevent="contextClick('delete', data)">Delete</a>
				</li>
			</vue-context>
			<b-modal id="noteFormModal" width="900px" parent="coverageModal" ref="noteFormModal" v-model="showFormModal" #default="props" :can-cancel="['x']">
				<div class="modal-card" style="width: auto">
					<header class="modal-card-head">
						<p class="modal-card-title">
							Notes
						</p>
					</header>
					<section class="modal-card-body">
						<div class="columns">
							<div class="column is-one-third">
								   <b-field label="Reference Number">
										<b-input v-if="!isEditing" v-model="viewModel.referenceNumber"></b-input>
										<b-input v-else v-model="viewModel.updatedReferenceNumber"></b-input>

								   </b-field>
							</div>
							
							
						</div>
                        <div class="columns">
                            <div class="column">
								   <b-field label="Name">
										<wto-ck-editor  v-if="!isEditing" :view-model-data.sync="viewModel.name"></wto-ck-editor>
										<wto-ck-editor  v-else :view-model-data.sync="viewModel.updatedText"></wto-ck-editor>

								   </b-field>
							</div>
                        </div>
                        <div class="columns">
							<div class="column is-one-third">
								   <b-field label="Defines Symbol">
										<b-input v-if="!isEditing" v-model="viewModel.definesSymbol"></b-input>
										<b-input v-else v-model="viewModel.updatedDefinesSymbol"></b-input>

								   </b-field>
							</div>
							<div class="column is-one-third">
								   <b-field label="Classification System">
										<b-input v-if="!isEditing" v-model="viewModel.classificationSystem"></b-input>
										<b-input v-else v-model="viewModel.updatedClassificationSystem"></b-input>
								   </b-field>
							</div>
							<div class="column is-one-third">
								   <b-field>
										 <b-checkbox v-model="viewModel.excluded"> This entry is an exclusion
                                         </b-checkbox>
								   </b-field>
							</div>
						</div>
					</section>
					<footer class="modal-card-foot buttons is-right">
						<b-button label="Save" @click="update"></b-button>
						<b-button label="Cancel" @click="props.close"></b-button>

					</footer>
				 </div>
			</b-modal>

          
		</div>
	`
});